import React, { useEffect, useState } from 'react';
import {
  Tooltip,
  Popover,
  Row,
  Col,
  Timeline,
  Button,
  Space,
  Spin,
  Tag,
  notification,
} from 'antd';
import {
  MailTwoTone,
  ExceptionOutlined,
  FileDoneOutlined,
  FileTwoTone,
  StopOutlined,
  EyeOutlined,
  CheckCircleOutlined,
  ThunderboltTwoTone,
  CloseCircleOutlined,
  BellTwoTone,
  DownCircleOutlined,
} from '@ant-design/icons';
import {
  ExecuteTaskConseqManual,
  ViewProcTaskCheckResponse,
  ViewProcTaskFollowUpResponse,
  ViewProcTaskNotifResponse,
} from 'services/workflow';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { downloadBlobFile } from 'utils/utils2';
import { isNull } from 'lodash';
import { manualRunPrintDocumentOrSendEmail } from 'services/printingService';
import { API_URLS } from 'utils/config';
import moment from 'moment';
import ButtonOperation from './ButtonOperation';
import ModalControllerNV from './ModalControllerNV';
import PreviewDocModal from './previewDoc/modalPreview';
import { genInvoiceFees } from 'services/clientInvoice';
type ProcedureDisplayProps = {
  task: ViewProcTaskFollowUpResponse;
  entityReference: string;
  refetch?: () => void;
  showAll: boolean;
};
const PRINTING_URL = API_URLS.PRINTING;
const ProcedureDisplay = (props: ProcedureDisplayProps) => {
  const { showAll, task, entityReference, refetch } = props;

  const [conseqids] = useState<Array<number>>([]);
  const [showTree, setShowTree] = useState(false);
  const [visible, setVisible] = useState(false);
  const [loadingnotif, setloadingnotif] = useState<any>();

  const ExecManual = (conseq: any) => {
    setloadingnotif(conseq.notifid);
    ExecuteTaskConseqManual({
      conseqid: conseq.conseqid,
      entity: conseq.entity,
      entityid: conseq.entityid,
      procid: conseq.procid,
      proctaskid: conseq.proctaskid,
      subentity: conseq.subentity ?? '',
      subentityid: isNull(conseq.subentityid) ? 0 : conseq.subentityid,
      taskid: conseq.taskid,
      objectreference: entityReference ?? '',
    })
      .then((res) => {
        if (res.success === true) {
          notification.success({ message: res.message });
        }
        setloadingnotif(null);
        refetch && refetch();
      })
      .catch(() => {
        setloadingnotif(null);
      });
  };

  const InvoicehandleRunManual = (item: any) => {
    setloadingnotif(item?.notifid);
    genInvoiceFees({
      ctetype: item.conseqcode,
      entity: item.procmodule,
      entityid: item.objectid,
      entitytarget: item.entitytarget,
      entitytaskidtarget: item.entitytaskidtarget,
      notifid: item.notifid,
    })
      .then((response) => {
        setloadingnotif(null);

        if (response.code === '200') {
          notification.success({
            message: `${item.conseqtype}  successfully created`,
          });
          refetch && refetch();
        } else {
          notification.error({
            message: response.message,
            description: response.description,
          });
        }
      })
      .catch(() => {
        setloadingnotif(null);
      });
  };

  const showMore = () => {
    if (showTree === true) {
      setShowTree(false);
    } else {
      setShowTree(true);
    }
  };
  const handleRunManual = (item: any) => {
    setloadingnotif(item?.notifid);
    manualRunPrintDocumentOrSendEmail({
      doccode: item.conseqcode,
      conseqid: item.conseqid,
      notifid: item.notifid,
      entityid: item.entityid,
      entity: item.entity,
      subentityid: item.subentityid ?? 0,
      subentity: item.subentity ?? '',
      flagEmail: item.conseqtype === 'EMAIL' ? 'true' : 'false',
      emailTo: item.emailtotarget,
      emailCc: item.emailcctarget,
    })
      .then((res) => {
        if (res.code === '200') {
          notification.success({ message: res.message });
        }
        setloadingnotif(null);

        refetch && refetch();
      })
      .catch(() => {
        setloadingnotif(null);
      });
  };

  useEffect(() => {
    setShowTree(showAll);
  }, [showAll]);

  const SortProcessDataByDateDesc = (
    list: ViewProcTaskFollowUpResponse[]
  ): ViewProcTaskFollowUpResponse[] => {
    return list.sort(
      (date1: any, date2: any) =>
        new Date(date2.taskstatusdate).setHours(0, 0, 0, 0) -
        new Date(date1.taskstatusdate).setHours(0, 0, 0, 0)
    );
  };

  return (
    <Timeline.Item
      dot={
        task?.taskstatus === 'INIT' ? (
          <Popover
            trigger="click"
            title="Task detail"
            style={{
              width: 400,
              backgroundColor: '#f5a623',
            }}
            placement="bottomLeft"
            content={
              <div style={{ width: 400 }}>
                <Row>
                  <Col span={12}> initiated : </Col>
                  <Col span={12}>
                    <b>
                      {moment(task?.startdate).format('YYYY-MM-DD HH:mm:ss')}
                    </b>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}> current status : </Col>
                  <Col>
                    <b>{task?.taskstatuslabel}</b>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>since</Col>
                  <Col>
                    {moment(task?.taskstatusdate).format('YYYY-MM-DD HH:mm:ss')}
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>Sender : </Col>
                  <Col>
                    <b>{task?.sendername}</b>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>to</Col>
                  <Col>
                    <b> {task?.receivertypelabel}</b>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}> Holder : </Col>
                  <Col>
                    <b>{task?.holdername}</b>{' '}
                  </Col>
                </Row>
                <Row>
                  <Col span={4}> Comment : </Col>
                  <Col>
                    <b>{task?.taskcomment}</b>{' '}
                  </Col>
                </Row>
              </div>
            }
          >
            <a style={{ color: '#f5a623' }}>
              <Tooltip title={task?.taskstatuslabel}>
                <ExceptionOutlined
                  onClick={() => setVisible(true)}
                  style={{ fontSize: '26px' }}
                  color="#f5a623"
                />
              </Tooltip>
            </a>
          </Popover>
        ) : (
          <Popover
            trigger="click"
            title="Task detail"
            style={{ width: 400, backgroundColor: '#293c72' }}
            placement="bottomLeft"
            content={
              <div style={{ width: 400 }}>
                <Row>
                  <Col span={12}> initiated : </Col>
                  <Col span={12}>
                    <b>
                      {moment(task?.startdate).format('YYYY-MM-DD HH:mm:ss')}
                    </b>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}> current status : </Col>
                  <Col>
                    <b>{task?.taskstatuslabel}</b>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>since</Col>
                  <Col>
                    {moment(task?.taskstatusdate).format('YYYY-MM-DD HH:mm:ss')}
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>Sender : </Col>
                  <Col>
                    <b>{task?.sendername}</b>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>to</Col>
                  <Col>
                    <b> {task?.receivertypelabel}</b>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}> Holder : </Col>
                  <Col>
                    <b>{task?.holdername}</b>{' '}
                  </Col>
                </Row>
                <Row>
                  <Col span={4}> Comment : </Col>
                  <Col>
                    <b>{task?.taskcomment}</b>{' '}
                  </Col>
                </Row>
              </div>
            }
          >
            <a
              onClick={() => setVisible(true)}
              style={
                task.modtype === 'SIMUL'
                  ? { color: '#00A896' }
                  : { color: '#293c72' }
              }
            >
              <Tooltip title={task?.taskstatuslabel}>
                <FileDoneOutlined style={{ fontSize: '26px' }} />
              </Tooltip>
            </a>
          </Popover>
        )
      }
      color={task?.taskstatus === 'INIT' ? '#f5a623' : '#293c72'}
      position="right"
      style={{ marginTop: 25 }}
    >
      <div>
        <Row
          justify="space-between"
          style={{
            boxShadow:
              'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px',
            padding: ' 4px 5px',
            borderRadius: ' 2px',
          }}
          onClick={() => {
            task?.procTaskConseq?.length > 0 && showMore();
          }}
        >
          <Col>
            <p style={{ marginBottom: 0, cursor: 'pointer' }}>
              <span
                style={{
                  color:
                    task?.taskstatus === 'INIT'
                      ? '#f5a623'
                      : task.modtype === 'SIMUL'
                      ? '#00A896'
                      : '#293c72',
                  fontWeight: 'bold',
                  fontSize: '15px',
                }}
              >
                {moment(task?.taskstatusdate).format('YYYY-MM-DD HH:mm:ss')}
              </span>
              <span
                style={{
                  marginLeft: 10,
                  marginRight: 10,
                  color:
                    task?.taskstatus === 'INIT'
                      ? '#f5a623'
                      : task.modtype === 'SIMUL'
                      ? '#00A896'
                      : '#293c72',
                  fontSize: '15px',
                }}
              >
                {task?.tasklabel2 === null
                  ? task?.tasklabel
                  : task?.tasklabel +
                    ' ' +
                    task?.tasklabel2 +
                    task?.taskstatuslabel}
              </span>
              <span
                style={{
                  marginLeft: 10,
                  marginRight: 10,
                  color:
                    task?.taskstatus === 'INIT'
                      ? '#f5a623'
                      : task.modtype === 'SIMUL'
                      ? '#00A896'
                      : '#293c72',
                  fontSize: '15px',
                }}
              >
                {task.modtype === 'SIMUL'
                  ? 'Simulation'
                  : task.modtype === 'EVENT'
                  ? 'Real'
                  : ''}
              </span>
              <Tag
                color={
                  task?.taskstatus === 'INIT'
                    ? '#f5a623'
                    : task.modtype === 'SIMUL'
                    ? '#00A896'
                    : '#293c72'
                }
              >
                {task?.taskstatuslabel}
              </Tag>
            </p>
          </Col>
          {task?.procTaskConseq?.length > 0 && (
            <Col
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <a>
                <GetLabel label="show" /> <DownCircleOutlined />
              </a>
            </Col>
          )}
        </Row>
        {showTree && (
          <div style={{ marginTop: 15 }}>
            {task?.procTaskCheck?.length > 0 && (
              <GetLabel
                style={{ fontSize: 15, fontWeight: 'bold' }}
                label="listprocTaskCheck"
              />
            )}

            {task?.procTaskCheck?.map(
              (check: ViewProcTaskCheckResponse, indC: any) => (
                <Row
                  key={indC}
                  style={{
                    marginLeft: 10,
                    position: 'relative',
                    left: -10,
                    marginBottom: 10,
                    marginTop: 10,
                  }}
                  gutter={32}
                >
                  <div
                    className="box red"
                    style={{
                      boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px',
                      borderRadius: 5,
                      padding: '15px 3px',
                      border: '1px solid #f5a623',
                      width: '100%',
                    }}
                  >
                    <Col>
                      <span style={{ fontWeight: 'bold', marginRight: 5 }}>
                        {moment(check.checkstatusdate).format(
                          'YYYY-MM-DD HH:mm:ss'
                        )}
                      </span>
                      {check.checkstatus === 'ACCEPT' ? (
                        <CheckCircleOutlined
                          style={{
                            fontSize: '16px',
                            color: 'green',
                            backgroundColor: '#fff ',
                          }}
                        />
                      ) : check.checkstatus === 'REFUS' ? (
                        <CloseCircleOutlined
                          style={{
                            fontSize: '16px',
                            color: '#FF5D25',
                            backgroundColor: '#fff ',
                          }}
                        />
                      ) : check.checkstatus === 'OVERRIDE' ? (
                        <StopOutlined
                          style={{
                            fontSize: '16px',
                            color: 'darkorange',
                            backgroundColor: '#fff ',
                          }}
                        />
                      ) : check.checkstatus === 'CANCEL' ? (
                        <CloseCircleOutlined
                          style={{
                            fontSize: '16px',
                            color: '#000',
                            backgroundColor: '#fff ',
                          }}
                        />
                      ) : null}
                    </Col>
                    <Col>
                      <b>{check.cmessage} :</b>
                      {check.requestvalue === null
                        ? ''
                        : ' ( ' + check.requestvalue}
                      {check.defaultvalue === null
                        ? ''
                        : ' / ' + check.defaultvalue + ' ) '}{' '}
                      &nbsp; &nbsp;
                      <br />
                      <b>Initiated by : </b>
                      {check.sendername}
                      <br />
                      <b>{check.checkstatuslabel + ' by '}:</b>{' '}
                      {check.usernamestatus}
                      <br />
                      <b> On : </b>
                      {check.checkstatusdate?.substring(0, 10)}
                    </Col>
                  </div>
                </Row>
              )
            )}

            <div>
              {task?.procTaskConseq?.length > 0 &&
                (task?.procTaskConseq?.find((e) => e.checkid !== null) ? (
                  ''
                ) : (
                  <GetLabel
                    style={{ fontSize: 15, fontWeight: 'bold' }}
                    label="listprocTaskConseq"
                  />
                ))}
            </div>

            {task?.procTaskConseq?.map(
              (conseq: ViewProcTaskNotifResponse, indK: any) =>
                conseq.proctaskcheckid === null ? (
                  <Row
                    justify="space-between"
                    key={indK}
                    style={{
                      marginBottom: 10,
                      marginTop: 8,
                      paddingLeft: 5,
                      padding: '2px 1px',
                      backgroundColor: 'rgb(163 182 191 / 18%)',
                      borderRadius: 5,
                      boxShadow:
                        'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px',
                    }}
                  >
                    <Col span={14}>
                      <div
                        style={{
                          paddingTop: 2,
                          display: 'flex',
                          width: '100%',
                        }}
                      >
                        {conseq.conseqtype === 'EMAIL' ? (
                          <Tooltip
                            placement="topLeft"
                            title={conseq.conseqstatuslabel}
                            style={{ color: '#f5a623' }}
                          >
                            <MailTwoTone
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                              }}
                              twoToneColor={
                                conseq.conseqstatus === 'CLOSED'
                                  ? '#293c72'
                                  : conseq.conseqstatus === 'INIT'
                                  ? '#f5a623'
                                  : conseq.conseqstatus === 'INPROGRES'
                                  ? '#89bb00'
                                  : 'red'
                              }
                            />
                          </Tooltip>
                        ) : conseq.conseqtype === 'PRINT' ? (
                          <Tooltip
                            placement="topLeft"
                            title={conseq.conseqstatuslabel}
                          >
                            <FileTwoTone
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                              }}
                              twoToneColor={
                                conseq.conseqstatus === 'CLOSED'
                                  ? '#293c72'
                                  : conseq.conseqstatus === 'INIT'
                                  ? '#f5a623'
                                  : conseq.conseqstatus === 'INPROGRES'
                                  ? '#89bb00'
                                  : 'red'
                              }
                            />
                          </Tooltip>
                        ) : conseq.conseqtype === 'NOTIF' ? (
                          <Tooltip
                            placement="topLeft"
                            title={conseq.conseqstatuslabel}
                          >
                            <BellTwoTone
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                              }}
                              twoToneColor={
                                conseq.conseqstatus === 'CLOSED'
                                  ? '#293c72'
                                  : conseq.conseqstatus === 'INIT'
                                  ? '#f5a623'
                                  : '#faad14'
                              }
                            />
                          </Tooltip>
                        ) : (
                          ''
                        )}
                        {conseq.printid !== null &&
                        conseq.conseqtype === 'PRINT' &&
                        conseq.conseqstatus === 'CLOSED' ? (
                          <a
                            style={{ width: '100%' }}
                            onClick={(ev) => {
                              ev.preventDefault();
                              downloadBlobFile(
                                `${conseq.conseqcode}-${conseq.entity}-${conseq.entityid}-${conseq.conseqid}.pdf`,
                                `${PRINTING_URL}/api/print/download?printid=${conseq.printid}`
                              );
                            }}
                          >
                            <Row
                              style={{ paddingLeft: 10 }}
                              justify="space-between"
                            >
                              <Col>{conseq.notifmessage}</Col>
                              <Col>
                                <Tag color="#293c72">
                                  {conseq?.conseqstatuslabel}
                                </Tag>
                              </Col>
                            </Row>
                          </a>
                        ) : (
                          <Row
                            style={{
                              display: 'flex',
                              width: '100%',
                              paddingLeft: 10,
                            }}
                            justify="space-between"
                          >
                            <Col>{conseq.notifmessage}</Col>
                            <Col>
                              <Tag
                                color={
                                  conseq.conseqstatus === 'INIT'
                                    ? '#f5a623'
                                    : conseq.conseqstatus === 'INPROGRES'
                                    ? 'warning'
                                    : '#293c72'
                                }
                              >
                                {conseq?.conseqstatuslabel}
                              </Tag>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </Col>
                    <Col span={10} style={{ textAlign: 'right' }}>
                      {(conseq.conseqstatus === 'INPROGRES' ||
                        conseq.conseqstatus === 'INIT' ||
                        conseq.conseqstatus === 'ERROR') &&
                        (conseq.conseqtype === 'PRINT' ||
                          conseq.conseqtype === 'EMAIL') && (
                          <Space size="small">
                            <Button
                              icon={
                                <ThunderboltTwoTone twoToneColor="#eb2f96" />
                              }
                              style={{ height: 30 }}
                              onClick={() => handleRunManual(conseq)}
                              loading={loadingnotif === conseq.notifid}
                              disabled={
                                conseqids.indexOf(conseq.conseqid) !== -1
                                  ? true
                                  : false
                              }
                            >
                              <GetLabel label="runmanual" />{' '}
                            </Button>
                          </Space>
                        )}
                      {conseq.conseqtype === 'NOTIF' && (
                        <ButtonOperation
                          onClick={() => ExecManual(conseq)}
                          key={indK}
                          icon={
                            <ThunderboltTwoTone
                              style={{ fontSize: 13 }}
                              twoToneColor="#eb2f96"
                            />
                          }
                          disabled={
                            conseq.proccodetarget !== null &&
                            localStorage.getItem('userrole') !== 'ADMIN'
                          }
                          loading={loadingnotif === conseq.notifid}
                          comcode={
                            conseq.proccodetarget === null
                              ? 'sendnotif'
                              : 'inittask'
                          }
                        />
                      )}
                      {(conseq.conseqtype === 'PRINT' ||
                        conseq.conseqtype === 'EMAIL') &&
                        conseq.conseqstatus !== 'INPROGRES' &&
                        conseq.printid !== null &&
                        conseq.printid !== 0 && (
                          <>
                            <Button
                              icon={
                                <ThunderboltTwoTone twoToneColor="#eb2f96" />
                              }
                              style={{ height: 30 }}
                              onClick={() => handleRunManual(conseq)}
                              loading={loadingnotif === conseq.notifid}
                              disabled={
                                conseqids.indexOf(conseq.conseqid) !== -1
                                  ? true
                                  : false
                              }
                            >
                              <GetLabel label="runagain" />{' '}
                            </Button>

                            <ModalControllerNV
                              modal={({ setVisible, visible }) => (
                                <PreviewDocModal
                                  visible={visible}
                                  setVisible={setVisible}
                                  conseq={conseq}
                                />
                              )}
                              content={({ setVisible, visible }) => (
                                <ButtonOperation
                                  onClick={(e) => {
                                    setVisible(true);
                                  }}
                                  icon={
                                    <EyeOutlined
                                      style={{ fontSize: 13 }}
                                      twoToneColor="#eb2f96"
                                    />
                                  }
                                  comcode="preview"
                                />
                              )}
                            />
                          </>
                        )}

                      {conseq.conseqtype === 'INVOICEF' && (
                        <Space size="small">
                          {conseq.conseqstatus === 'INPROGRES' && (
                            <>
                              <span>Please wait...</span>
                              <div
                                style={{
                                  display: 'flex',
                                  alignContent: 'center',
                                }}
                              >
                                <Spin size="small" />
                              </div>
                            </>
                          )}
                          {conseq.conseqstatus === 'INPROGRES' ? (
                            <ButtonOperation
                              onClick={() => InvoicehandleRunManual(conseq)}
                              icon={
                                <ThunderboltTwoTone
                                  style={{ fontSize: 13 }}
                                  twoToneColor="#eb2f96"
                                />
                              }
                              loading={loadingnotif === conseq.notifid}
                              comcode="ManualInvoicingrun"
                            />
                          ) : (
                            <ButtonOperation
                              onClick={() => ExecManual(conseq)}
                              icon={
                                <ThunderboltTwoTone
                                  style={{ fontSize: 13 }}
                                  twoToneColor="#eb2f96"
                                />
                              }
                              loading={loadingnotif === conseq.notifid}
                              comcode="ExecManual"
                            />
                          )}
                        </Space>
                      )}
                    </Col>
                  </Row>
                ) : null
            )}
          </div>
        )}
        <Timeline mode="left" style={{ marginTop: 5 }}>
          {SortProcessDataByDateDesc(task?.procTaskChild)?.map(
            (taskChild: ViewProcTaskFollowUpResponse, index: any) => (
              <Timeline.Item
                key={index}
                dot={<div style={{ display: 'none' }}></div>}
              >
                <ProcedureDisplay
                  refetch={refetch}
                  task={taskChild}
                  key={index}
                  entityReference={entityReference}
                  showAll={showAll}
                />
              </Timeline.Item>
            )
          )}
        </Timeline>
      </div>
    </Timeline.Item>
  );
};

export default ProcedureDisplay;
